module.exports = __webpack_public_path__ + "static/media/dropdown_icon.b2701e9b.svg";